var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-card',{attrs:{"width":"200"}},[_c('v-system-bar',{attrs:{"color":"success"}},[_vm._v(" Absenzenabschluss "),_c('v-spacer'),_vm._v(_vm._s(this.items.length)+" ")],1),_c('v-list',_vm._l((_vm.items),function(item){return _c('SchoolClass',{key:item.id,attrs:{"small":"","value":item,"clickable":""}})}),1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }